var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: { timeout: 30000, top: true, color: _vm.toastColor },
              model: {
                value: _vm.toastEnable,
                callback: function($$v) {
                  _vm.toastEnable = $$v
                },
                expression: "toastEnable"
              }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.toastText) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.toastEnable = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem) {
            return _c("v-tab", { key: tabItem }, [
              _vm._v("\n        " + _vm._s(tabItem) + "\n      ")
            ])
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(2, function(item, index) {
              return _c("v-tab-item", { key: "item" + index }, [
                _vm.tab === 0 && index === 0
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-layout",
                          { attrs: { "justify-start": "" } },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", nowrap: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          color: "primary",
                                          id: "addProduct"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showAddProductDialog.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { dark: "" } }, [
                                          _vm._v("add")
                                        ]),
                                        _vm._v(_vm._s(_vm.$t("addProduct")))
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: { "offset-y": "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        dark: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return on.click.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t("export")
                                                          ) +
                                                          " "
                                                      ),
                                                      _c("v-icon", [
                                                        _vm._v("expand_more")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "v-list",
                                          [
                                            _c(
                                              "v-list-tile",
                                              {
                                                on: {
                                                  click: _vm.exportAllInventory
                                                }
                                              },
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("exportAll"))
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.selectedProducts.length
                                              ? _c(
                                                  "v-list-tile",
                                                  {
                                                    on: {
                                                      click:
                                                        _vm.exportSelectedInventory
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-tile-title", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "exportSelected"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          disabled:
                                            _vm.selectedProducts.length === 0
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.batchArchive.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("archiveSelected"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          disabled:
                                            _vm.selectedProducts.length === 0
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.batchPrintBarcode.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("print")) + " UPC")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.unlinkPackageInfo.exists
                              ? _c(
                                  "v-flex",
                                  { attrs: { "align-self-center": "" } },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "align-center": "",
                                          "justify-center": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { subheading: "" } },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "padding-right": "5px"
                                                }
                                              },
                                              [_vm._v("info")]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs12: "", subheading: "" }
                                          },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "span",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticStyle: {
                                                                    cursor:
                                                                      "pointer",
                                                                    "text-decoration":
                                                                      "underline",
                                                                    color:
                                                                      "#2196f3"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.goUnlinkPackage
                                                                  }
                                                                },
                                                                "span",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "hasUnlinkPackage"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("updateTime")
                                                    ) +
                                                      ": " +
                                                      _vm._s(
                                                        _vm.toDateYYYYMMDDHHmmss(
                                                          _vm.unlinkPackageInfo
                                                            .updateTime
                                                        )
                                                      )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { "align-self-center": "" } },
                              [
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "align-center": "",
                                      "justify-center": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs6: "", subheading: "" } },
                                      [
                                        _vm._v(_vm._s(_vm.$t("total")) + ": "),
                                        _c("span", [
                                          _vm._v(
                                            "$" +
                                              _vm._s(
                                                _vm.products
                                                  .reduce(function(sum, ref) {
                                                    var value = ref.value

                                                    return _vm.addNumbers(
                                                      sum,
                                                      value || 0
                                                    )
                                                  }, 0)
                                                  .toLocaleString()
                                              )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs6: "", subheading: "" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("currentPage")) + ": "
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            "$" +
                                              _vm._s(
                                                (_vm.$refs.rtProductsTable &&
                                                  _vm.$refs
                                                    .rtProductsTable[0] &&
                                                  _vm.$refs.rtProductsTable[0].filteredItems
                                                    .reduce(function(sum, ref) {
                                                      var value = ref.value

                                                      return _vm.addNumbers(
                                                        sum,
                                                        value || 0
                                                      )
                                                    }, 0)
                                                    .toLocaleString()) ||
                                                  0
                                              )
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs4: "", md2: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "append-icon": "filter_list",
                                    label: _vm.$t("search"),
                                    "single-line": "",
                                    "hide-details": "",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filter,
                                    callback: function($$v) {
                                      _vm.filter = $$v
                                    },
                                    expression: "filter"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            attrs: { "justify-start": "", "align-baseline": "" }
                          },
                          [
                            _c(
                              "v-flex",
                              { staticClass: "success--text caption" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "realtime-border px-1" },
                                  [_vm._v(_vm._s(_vm.$t("realTIME")))]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-data-table", {
                          ref: "rtProductsTable",
                          refInFor: true,
                          staticClass: "elevation-2 myDense",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.products,
                            search: _vm.filter,
                            "select-all": "blue",
                            pagination: _vm.pagination,
                            "item-key": "id",
                            rowsPerPageItems: _vm.rowsPerPageItems
                          },
                          on: {
                            "update:pagination": function($event) {
                              _vm.pagination = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "tr",
                                      {
                                        attrs: { active: props.selected },
                                        on: {
                                          click: function($event) {
                                            props.selected = !props.selected
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "td",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                primary: "",
                                                "hide-details": ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  props.selected = !props.selected
                                                }
                                              },
                                              model: {
                                                value: props.selected,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    props,
                                                    "selected",
                                                    $$v
                                                  )
                                                },
                                                expression: "props.selected"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "subheading" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.id &&
                                                  props.item.id.slice(-5)
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c("ProductWidget", {
                                              attrs: {
                                                name: props.item.name,
                                                condition: props.item.condition,
                                                price: props.item.price,
                                                asin: props.item.asin,
                                                note: props.item.note,
                                                size: _vm.displaySize(
                                                  props.item
                                                ),
                                                sku: props.item.sku
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.upc))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.inbound))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(props.item.quantity))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.value &&
                                                  "$" +
                                                    props.item.value.toLocaleString()
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-right" },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: { row: "", nowrap: "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      dark: "",
                                                      color: "primary",
                                                      flat: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.showProductDetail(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("detail"))
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      dark: "",
                                                      color: "primary",
                                                      flat: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.showAddOfferDialog(
                                                          {
                                                            initProduct:
                                                              props.item
                                                          }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("addOffer"))
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-menu",
                                                  {
                                                    attrs: { "offset-y": "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    dark: "",
                                                                    flat: "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return on.click.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "more"
                                                                        )
                                                                      )
                                                                  ),
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "expand_more"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list",
                                                      [
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.showEditProductDialog(
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "edit"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.printBarcode(
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "print"
                                                                    )
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "upc"
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.archiveSingleProduct(
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "archive"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.memberType > 0
                                                          ? _c(
                                                              "v-list-tile",
                                                              {
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.showMergeProductDialog(
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "merge"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.selectedProducts,
                            callback: function($$v) {
                              _vm.selectedProducts = $$v
                            },
                            expression: "selectedProducts"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === 1 && index === 1
                  ? _c(
                      "div",
                      [
                        _c("PaginationController", {
                          attrs: {
                            getDataActionName: "getArchivedProducts",
                            historyLimit: _vm.historyLimit,
                            haveSearchBox: true,
                            searchBoxLabel: _vm.$t("keyword/upc/asin")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "dataTable",
                                fn: function() {
                                  return [
                                    _c("v-data-table", {
                                      staticClass: "elevation-2 myDense",
                                      attrs: {
                                        headers: _vm.headers,
                                        items: _vm.archivedProducts,
                                        "hide-actions": ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  { staticClass: "subheading" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item._key &&
                                                          props.item._key.slice(
                                                            -5
                                                          )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  [
                                                    _c("ProductWidget", {
                                                      attrs: {
                                                        name: props.item.name,
                                                        condition:
                                                          props.item.condition,
                                                        price: props.item.price,
                                                        asin: props.item.asin,
                                                        note: props.item.note,
                                                        sku: props.item.sku
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.toDateString(
                                                          props.item.createTime
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.item.upc)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.item.inbound)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-right"
                                                  },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      { attrs: { row: "" } },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  dark: "",
                                                                  color:
                                                                    "primary",
                                                                  flat: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.showProductDetail(
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("Detail")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  dark: "",
                                                                  color:
                                                                    "primary",
                                                                  flat: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.restoreProduct(
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Restore"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.archivedProducts,
                            callback: function($$v) {
                              _vm.archivedProducts = $$v
                            },
                            expression: "archivedProducts"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            }),
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.editProductDialog
        ? _c("ProductEdit", {
            attrs: {
              title: _vm.$t("editProduct"),
              actionFunc: _vm.editProduct,
              product: _vm.productInEdit,
              editMode: true
            },
            model: {
              value: _vm.editProductDialog,
              callback: function($$v) {
                _vm.editProductDialog = $$v
              },
              expression: "editProductDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addProductDialog
        ? _c("ProductEdit", {
            attrs: {
              title: _vm.$t("addProduct"),
              actionText: "Add",
              actionFunc: _vm.addProduct,
              product: _vm.productInEdit
            },
            model: {
              value: _vm.addProductDialog,
              callback: function($$v) {
                _vm.addProductDialog = $$v
              },
              expression: "addProductDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.productsMergeDialog
        ? _c("ProductsMerge", {
            attrs: {
              title: "Merge products",
              actionText: "Merge",
              actionFunc: _vm.mergeProducts,
              product: _vm.productInEdit
            },
            model: {
              value: _vm.productsMergeDialog,
              callback: function($$v) {
                _vm.productsMergeDialog = $$v
              },
              expression: "productsMergeDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.productDetailDialog
        ? _c("ProductDetail", {
            attrs: { product: _vm.productInEdit },
            model: {
              value: _vm.productDetailDialog,
              callback: function($$v) {
                _vm.productDetailDialog = $$v
              },
              expression: "productDetailDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addOfferDialog
        ? _c("OfferEdit", {
            attrs: {
              title: _vm.$t("addOffer"),
              actionText: _vm.$t("add"),
              actionFunc: _vm.addOffer,
              initProduct: _vm.initProduct
            },
            model: {
              value: _vm.addOfferDialog,
              callback: function($$v) {
                _vm.addOfferDialog = $$v
              },
              expression: "addOfferDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3946c026", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3946c026","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InventoryTenant.vue
// module id = null
// module chunks = 